import {cookie} from '@/_utils/cookie'
import {notification} from '@/_utils/notification'
import Vue from 'vue'
import {router} from '@/router'

const reqBase = {
    
    interceptorsRequest(req) {
        
        req.baseURL = `${Vue.prototype.$Params.urlBase}api/`;

        let _cookieToken = cookie.getToken();
        
        if (_cookieToken) {
            req.headers.Authorization = `Bearer ${_cookieToken}`;
        }
        return req
    },
    interceptorsResponse(response) {
        
        if(response.status == 200 && response.data.type!=undefined && response.data.type=='Success')
            notification.success(response.data.message);

        if(response.status == 200 && response.data.type!=undefined && response.data.type=='Warning')
            notification.warning(response.data.message);
		
        this.unauthorizedResponse(response);
        
        if(response.status != 401 && response.status != 404) {
            
            if(response.data['type'] && response.data.type=='Error')
                notification.error(response.data['message']);
            
            if(response['type'] && response.type=='Error') {
                notification.error(response.data)
            }
        }
    },
    unauthorizedResponse(response) {
        if((response.status == 401 || response.status == 403) && router.currentRoute.name!='start')
        {
            router.push('/');
        }
    }
}

export default reqBase